module.exports = __webpack_public_path__ + "img/salas_estudio2.80a51afe.png";